export default __webpack_public_path__ + "static/media/0.6ba0a0b4.jpg";